
import { mapActions, mapState, mapGetters } from "vuex";
import { SETTINGS_PAGE_VISITED } from "@/constants/MixpanelEvents.js";
import CommonHeaderMobile from "../../components/common/common-header-mobile.vue";
import AppMembersSection from "../../components/apps/app-members-section.vue";
import AppReceiverUserAccess from "../../components/apps/app-receiver-user-access.vue";

export default {
  components: { CommonHeaderMobile, AppMembersSection, AppReceiverUserAccess },
  beforeMount() {
    if (!(this.apps && this.apps.length)) this.fetchApps();
  },
  mounted() {
    this.mixPanelTrackEvent(SETTINGS_PAGE_VISITED);
  },
  computed: {
    ...mapGetters("apps", ["getApp", "getMyApps"]),
    ...mapState("apps", ["apps"]),
    ...mapState("restaurant", ["linkedApps"]),
    appDetail() {
      console.log(this.getApp(4));
      return this.getApp(4);
    },
    isSubscribed() {
      return (
        this.appDetail &&
        this.getMyApps.find((app) => {
          return app.identifier == this.appDetail.identifier;
        })
      );
    }
  },
  methods: {
    ...mapActions("apps", ["fetchApps"])
  }
};
